export const noop = () => {}

export const preventDefault = (f = noop) => e => {
    e.preventDefault()
    f()
    return false
}


// WEBPACK FOOTER //
// ./js/utils.js